module.exports = __webpack_public_path__ + "static/img/newsCon_img.36604e22.png";